import { EmployeeLoan } from "./employee-loan/employee-loan";

export const LoanSection = () => {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-lg font-medium tracking-wide underline underline-offset-2">
        Loan
      </h1>

      <div className="flex flex-wrap gap-6">
        <EmployeeLoan />
      </div>
    </div>
  );
};
